import { createStore } from "@halka/state";
import produce from "immer";
import clamp from "clamp";
import { nanoid } from "nanoid";

import { SHAPE_TYPES, DEFAULTS, LIMITS } from "./constants";

const APP_NAMESPACE = "toothlens-annotation";

const baseState = {
  selected: null,
  shapes: {},
};

export const useShapes = createStore(() => {
  let initialState;
//   let initialState =  { "qCshHijvxtfb_7xRlVXxf": {
//     "type": "rect",
//     "width": 100,
//     "height": 100,
//     "fill": "transparent",
//     "stroke": "#000000",
//     "rotation": 0,
//     "x": 656,
//     "y": 334
// } } //JSON.parse(localStorage.getItem(APP_NAMESPACE));
  // console.log("baseState", baseState, initialState);

  return { ...baseState, shapes: initialState ?? {} };
});
const setState = (fn) => useShapes.set(produce(fn));

export const saveDiagram = () => {
  const state = useShapes.get();

  localStorage.setItem(APP_NAMESPACE, JSON.stringify(state.shapes));
};

export const reset = () => {
  localStorage.removeItem(APP_NAMESPACE);

  useShapes.set(baseState);
};

export const createRectangle = ({ width, height, x, y }, tagData) => {
  // const width = endPos.x - x;
  // const height = endPos.y - y;
  
  if (width > 2 && height > 2) {
    setState((state) => {
      state.shapes[nanoid()] = {
        name: tagData?.name,
        type: SHAPE_TYPES.RECT,
        width, // DEFAULTS.RECT.WIDTH
        height, // DEFAULTS.RECT.HEIGHT
        fill: 'transparent', //DEFAULTS.RECT.FILL,
        stroke: tagData?.color, //DEFAULTS.RECT.STROKE,
        rotation: DEFAULTS.RECT.ROTATION,
        tagType: tagData.tagType,
        x,
        y,
      };
    });
  }

};

export const createCircle = ({ x, y }) => {
  setState((state) => {
    state.shapes[nanoid()] = {
      type: SHAPE_TYPES.CIRCLE,
      radius: DEFAULTS.CIRCLE.RADIUS,
      fill: DEFAULTS.CIRCLE.FILL,
      stroke: DEFAULTS.CIRCLE.STROKE,
      x,
      y,
    };
  });
};

export const selectShape = (id) => {
  setState((state) => {
    state.selected = id;
  });
};

export const clearSelection = () => {
  setState((state) => {
    state.selected = null;
  });
};

export const getShapesData = () => {
  return useShapes.get()
};

export const editShape = (shapeData, tagData) => {
  setState((state) => {
    const shape = state.shapes[shapeData.id];

    if (shape) {
      shape.fill = shapeData.fill;
      shape.rotation = shapeData.rotation;
      shape.type = 'rect'; //shapeData.type
      shape.name  = tagData.name;
      shape.tagType = tagData.tagType;
      shape.stroke = tagData.color;
      shape.width = shapeData.width;
      shape.height = shapeData.height;
      shape.x = shapeData.x;
      shape.y = shapeData.y;
    }
  });
};

export const deleteShape = (shapeId) => {
  const shapesData = useShapes.get();
  const newShapeData = { ...shapesData.shapes };
  delete newShapeData[shapeId];
  // console.log("after delete", newShapeData);
  setState((state) => {
    state.shapes = newShapeData;
  });
};

export const moveShape = (id, event) => {
  setState((state) => {
    const shape = state.shapes[id];

    if (shape) {
      shape.x = event.target.x();
      shape.y = event.target.y();
    }
  });
};

export const updateAttribute = (attr, value) => {
  setState((state) => {
    const shape = state.shapes[state.selected];

    if (shape) {
      shape[attr] = value;
    }
  });
};

export const transformRectangleShape = (node, id, event) => {
  // transformer is changing scale of the node
  // and NOT its width or height
  // but in the store we have only width and height
  // to match the data better we will reset scale on transform end
  const scaleX = node.scaleX();
  const scaleY = node.scaleY();

  // we will reset the scale back
  node.scaleX(1);
  node.scaleY(1);
  
  // console.log("id", id);
  setState((state) => {
    const shape = state.shapes[id];

    if (shape) {
      // console.log("shape", shape.width, shape.height);
      shape.x = node.x();
      shape.y = node.y();

      shape.rotation = node.rotation();

      shape.width = clamp(
        // increase the width in order of the scale
        node.width() * scaleX,
        // should not be less than the minimum width
        LIMITS.RECT.MIN,
        // should not be more than the maximum width
        LIMITS.RECT.MAX
      );
      shape.height = clamp(
        node.height() * scaleY,
        LIMITS.RECT.MIN,
        LIMITS.RECT.MAX
      );
    }
  });
};

export const transformCircleShape = (node, id, event) => {
  // transformer is changing scale of the node
  // and NOT its width or height
  // but in the store we have only width and height
  // to match the data better we will reset scale on transform end
  const scaleX = node.scaleX();

  // we will reset the scale back
  node.scaleX(1);
  node.scaleY(1);

  setState((state) => {
    const shape = state.shapes[id];

    if (shape) {
      shape.x = node.x();
      shape.y = node.y();

      shape.radius = clamp(
        (node.width() * scaleX) / 2,
        LIMITS.CIRCLE.MIN,
        LIMITS.CIRCLE.MAX
      );
    }
  });
};
